import type { QueryKey } from '@tanstack/react-query';
import type { GetReceiptsParams, ReceiptsAndReceiptBatchesParams } from './api';

export const SUBMIT_RECEIPTS_KEY: QueryKey = ['submit-receipts'];
export const REFUND_RECEIPTS_KEY: QueryKey = ['refund-receipts'];
export const GET_RECEIPT_KEY: (
  receiptId: string,
  preloads?: {
    cash_list_transaction_group_link?: boolean;
    receipt_batch_entry?: boolean;
  }
) => QueryKey = (receiptId, preloads) => {
  if (preloads) {
    return ['receipt-phoenix', receiptId, preloads];
  }
  return ['receipt-phoenix', receiptId];
};

export const RECEIPTS_INDEX_KEY = (
  params?: Partial<GetReceiptsParams>
): QueryKey => {
  const base = 'receipts-phoenix-index';
  if (params) {
    return [base, params];
  }
  return [base];
};

export const RECEIPTS_AND_RECEIPT_BATCHES_PHOENIX_KEY = (
  nursingHomeId?: string,
  params?: Partial<Omit<ReceiptsAndReceiptBatchesParams, 'nursingHomeId'>>
): QueryKey => {
  const base = 'receipts-and-receipt-batches-phoenix';
  if (nursingHomeId) {
    if (params) {
      return [base, nursingHomeId, params];
    }
    return [base, nursingHomeId];
  }
  return [base];
};

export const FAMILY_MEMBER_RECEIPTS_KEY = (
  residentId: string,
  tenant: string
): QueryKey => ['family-member-receipts', residentId, tenant];
